import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { PaymentResponseMessageTypeFormComponent } from './payment-response-message-type-form.component';

@NgModule({
  declarations: [PaymentResponseMessageTypeFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    InputMaskModule,
    ButtonModule,
    FileUploadModule,
    ToastModule,
    EditorModule,
    FieldsetModule,
    TooltipModule,
    ConfirmDialogModule,
    AutoCompleteModule,
    DropdownModule
  ],
  exports: [PaymentResponseMessageTypeFormComponent]
})
export class PaymentResponseMessageTypeFormModule {}
